/**
 * Fetches an image from the given source URL and returns it as a base64-encoded data URL.
 * @internal
 */
export async function fetchIcon(src: string): Promise<string> {
  const res = await fetch(src);
  if (!res.ok) {
    throw new Error('Failed to fetch icon');
  }

  const contentType = res.headers.get('Content-Type') ?? '';
  if (!contentType.startsWith('image/')) {
    throw new Error('Failed to fetch icon');
  }

  const blob = await res.blob();

  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () =>
      resolve(typeof reader.result === 'string' ? reader.result : '');
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
